import { createContext, useContext, useState, useCallback } from "react";
import { TournamentLink } from "./TournamentLink";
import { useYear } from "../../../context/YearContext";
import { TournamentData } from "./TournamentData";
import { tournamentDataByCategory } from "./results.js";

const ROUNDS = ["round16", "round8", "round4", "round3", "round2"];

// 2025 대진은 서버 대신 직접 입력해 둔 결과(results.js)를 씀
// (2025 145m 본선은 조별 방식이라 서버 데이터로는 대진표를 그릴 수 없음)
const resultsTournament = (gender, distance) => {
  const data = tournamentDataByCategory[`${gender.toLowerCase()}-distance${distance}`];
  if (!data) return null;
  const tournament = { fromResults: true };
  ROUNDS.forEach((round) => {
    tournament[round] = (data[round] || []).map((match, i) => {
      const names = [match.player1, match.player2];
      return TournamentData.fromJson({
        jo_number: i + 1,
        winner_id: match.winner ? names[match.winner - 1] : null,
        players: names
          .filter((name) => name && name !== "?")
          .map((name) => ({ player_id: name, player_name: name })),
      });
    });
  });
  return tournament;
};

const TournamentContext = createContext();

export const TournamentProvider = ({ children }) => {
  const { year } = useYear();
  const [tournament, setTournament] = useState({
    round16: [],
    round8: [],
    round4: [],
    round3: [],
    round2: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTournament = useCallback(async (gender, distance) => {
    setLoading(true);
    setError(null);

    try {
      const results = year === "2025" && resultsTournament(gender, distance);
      if (results) {
        setTournament(results);
        return;
      }
      const link = new TournamentLink();
      await link.request(gender, distance, year);
      setTournament(link.tournament);
    } catch (error) {
      console.error("Failed to fetch tournament:", error);
      setError(error.message);
      setTournament({
        round16: [],
        round8: [],
        round4: [],
        round3: [],
        round2: [],
      });
    } finally {
      setLoading(false);
    }
  }, [year]);

  const value = {
    tournament,
    loading,
    error,
    fetchTournament,
  };

  return (
    <TournamentContext.Provider value={value}>
      {children}
    </TournamentContext.Provider>
  );
};

export const useTournament = () => {
  const context = useContext(TournamentContext);
  if (!context) {
    throw new Error("useTournament must be used within a TournamentProvider");
  }
  return context;
};
